import { teamEmailAddressSchema } from "@redotech/redo-model/email/domain-verification";
import * as z from "zod/v4";

export const getDkimVerifiedFromAddressesForTeam = {
  name: "getDkimVerifiedFromAddressesForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(teamEmailAddressSchema),
};
